import { AppText, FlexDiv } from "src/Components/UI";
import { getIntegrationLabel } from "src/utils/format";
import { theme } from "src/utils/theme";
import { IntegrationItem } from "src/types/StateTypes";
import * as React from "react";

interface InfoSectionProps {
  integration: IntegrationItem;
  timekitReplacementOrg: boolean;
}

const InfoSection = ({ integration, timekitReplacementOrg }: InfoSectionProps) => {
  return (
    <FlexDiv direction="column" gap={4}>
      <AppText fontSize={16} style={{ fontWeight: 600 }}>
        {getIntegrationLabel(integration.name, timekitReplacementOrg)}
      </AppText>
      <AppText fontSize={14} style={{ color: theme.NEUTRAL300 }}>
        {integration.description}
      </AppText>
    </FlexDiv>
  );
};

export default InfoSection;
